import { render, staticRenderFns } from "./EmployeeEditor.vue?vue&type=template&id=0a5a6c78&scoped=true"
import script from "./EmployeeEditor.vue?vue&type=script&lang=js"
export * from "./EmployeeEditor.vue?vue&type=script&lang=js"
import style0 from "./EmployeeEditor.vue?vue&type=style&index=0&id=0a5a6c78&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a6c78",
  null
  
)

export default component.exports